<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>send</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <h3>¿Está seguro de enviar el permiso?</h3>
        <br />
        <h4>Nota: Ya no podrá realizar cambios</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> No </v-btn>
        <v-btn
          color="success"
          @click.prevent="editControlPermiso()"
          :loading="loading"
        >
          Sí
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null,
      id_persona: null,
      rol: {}
    };
  },
  mounted() {
    this.$bus.$on("openDialogSolicitarPermiso", item => {
      this.id = item.permiso.id;
      this.permiso = item;
      this.dialog = true;
    });
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: `NOTIFICACIÓN SOLICITUD DE PERMISO`,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.$bus.$emit("closeDialog");
    },

    async editControlPermiso() {
      let correcto;
      let user = this.$storage.get("user");
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      let id_persona = this.$route.params.id;
        try {
          console.log(`
							query{
								runQuery(consulta:"select control.fn_solicita_cta_vacacion(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`)
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_solicita_cta_vacacion(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_cta_vacacion;
          let resps2 = resp.split("|");
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        } 
      await this.enviarCorreoDestinatario(permiso_copia);
      this.loading = false;
    },

    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/SolicitarPermiso.vue